module.exports = __webpack_public_path__ + "static/media/pickup_pass.aff3e9aa.svg";